// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"4ab185f2","411":"ce876bf8","739":"ce876bf8"}[chunkId] + ".chunk.css";
};